import React, { PureComponent } from 'react'
import PropTypes from 'prop-types';
import Chart from "chart.js";
import moment from 'moment';

//--Chart Style Options--//
Chart.defaults.global.defaultFontFamily = "'branding-medium'"
Chart.defaults.global.legend.display = false;
//--Chart Style Options--//

class BarChart extends PureComponent {
    chartRef = React.createRef();

    componentDidMount() {
        this.buildChart();
    }

    componentDidUpdate() {
        this.myChart.destroy();
        this.buildChart();
    }

    buildChart = () => {
        var { EndDate, Increment, Measurements, Maximum, Minimum, Orientation, StartDate } = this.props;

        var data = this.buildChartData({ Measurements });
        var type = Orientation.toLowerCase() === 'vertical' ? 'bar' : 'horizontalBar';

        this.myChart = new Chart(this.chartRef.current, {
            type,
            data,
            options: {
                scales: {
                    xAxes: [{
                        type: 'time',
                        time: {
                            unit: 'day'
                        },
                        ticks: {
                            max: EndDate,
                            min: StartDate,
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            max: Maximum,
                            min: Minimum,
                            stepSize: Increment
                        }
                    }]
                }
            }
        })

        // this.myChart = new Chart(this.chartRef.current, {
        //     type,
        //     data: { datasets },
        //     options: {
        //         responsive: true,
        //         maintainAspectRatio: false,
        //         // In v2.9.3, `plugins` were not used. Tooltips and titles were direct properties of `options`.
        //         title: {
        //             display: true,
        //             text: 'Daily Calorie Intake',
        //             fontSize: 18 // v2.x uses `fontSize`
        //         },
        //         tooltips: {
        //             callbacks: {
        //                 // v2.x callbacks use (tooltipItems, data) arguments
        //                 title: function(tooltipItems, data) {
        //                     // tooltipItems[0].xLabel is the parsed date string in v2.x
        //                     const dateString = tooltipItems[0].xLabel;
        //                     // Use Moment.js for formatting
        //                     return moment(dateString).format('MMM D, YYYY');
        //                 },
        //                 // v2.x callbacks use (tooltipItem, data) arguments
        //                 label: function(tooltipItem, data) {
        //                     return ` Calories: ${tooltipItem.yLabel}`;
        //                 }
        //             }
        //         },
        //         legend: {
        //             display: false
        //         },
                
        //         // ⭐ CRUCIAL: v2.x uses xAxes and yAxes arrays ⭐
        //         scales: {
        //             xAxes: [{
        //                 // Use 'time' scale for continuous dates
        //                 type: 'time', 
        //                 time: {
        //                     unit: 'day', // Base unit for the timeline
        //                     displayFormats: {
        //                         day: 'MMM D' // Format for axis ticks (e.g., Nov 13)
        //                     },
        //                     // v2.x moment.js specific property for tooltip date formatting
        //                     tooltipFormat: 'YYYY-MM-DD', 
        //                 },
        //                 ticks: {
        //                     min: StartDate,
        //                     max: EndDate,
        //                 },
        //                 // These properties help position the bars correctly on the time axis
        //                 distribution: 'series',
        //                 bounds: 'ticks',
        //                 scaleLabel: {
        //                     display: true,
        //                     labelString: 'Date'
        //                 },
        //                 gridLines: {
        //                     display: false
        //                 }
        //             }],
        //             yAxes: [{
        //                 ticks: {
        //                     // Explicitly set min/max for the Y-axis
        //                     min: Minimum,
        //                     max: Maximum,
                            
        //                     beginAtZero: true,
        //                     // Add 'kcal' to the y-axis ticks
        //                     callback: function(value) {
        //                         return value + ' kcal';
        //                     }
        //                 },
        //                 scaleLabel: {
        //                     display: true,
        //                     labelString: 'Calories (kcal)'
        //                 }
        //             }]
        //         }
        //     }
        // });
    }

    buildChartData = ({ Measurements }) => {
        var datasets = [];

        var INITIAL_DATASET = {
            data: [],
            backgroundColor: 'rgba(39, 71, 117, 1.0)',
            borderWidth: 1,
            // Fix for small bars on time scale: these ensure bars occupy the day slot
            barPercentage: 0.9,
            categoryPercentage: 1.0
        };

        datasets.push({
            ...INITIAL_DATASET,
            data: Measurements.map(({ Measurement: y, MeasurementDate: x }) => ({ x: moment(x).format('YYYY-MM-DD'), y }))
        });

        return { datasets };
    }

    render() {

        return (
            <div>
                <canvas ref={this.chartRef} />
            </div>
        )
    }
}

BarChart.propTypes = {
    EndDate: PropTypes.string,
    Increment: PropTypes.number,
    Measurements: PropTypes.array.isRequired,
    Maximum: PropTypes.number.isRequired,
    Minimum: PropTypes.number.isRequired,
    Orientation: PropTypes.string,
    StartDate: PropTypes.string,
}

BarChart.defaultProps = {
    Orientation: 'vertical'
}

export default BarChart;